import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

interface ResourceCalendarConfigSkeletonProps {
  isEditMode?: boolean;
}

export default function ResourceCalendarConfigSkeleton({
  isEditMode = false,
}: ResourceCalendarConfigSkeletonProps) {
  return (
    <Box gap={2} width={'100%'}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          width: '100%',
          mb: 2,
        }}
      >
        <Skeleton variant="circular" width={8} height={8} />
        <Skeleton variant="text" width={250} height={24} />
      </Stack>

      <Stack flexDirection="row" gap={2} pb={3}>
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 300 }}
        />
        <Box sx={{ flex: 1, minWidth: 300 }} />
      </Stack>

      {!isEditMode && (
        <Stack flexDirection="row" gap={2} pb={3}>
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ flex: 1, minWidth: 300 }}
          />
          <Box
            sx={{
              flex: 1,
              minWidth: 300,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Stack flexDirection="row" alignItems="center" spacing={1}>
              <Skeleton variant="rectangular" width={20} height={20} />
              <Skeleton variant="text" width={100} height={20} />
            </Stack>
          </Box>
        </Stack>
      )}

      {isEditMode && (
        <Stack flexDirection="row" gap={2} pb={3}>
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ flex: 1, minWidth: 300 }}
          />
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ flex: 1, minWidth: 300 }}
          />
        </Stack>
      )}

      <Stack flexDirection={'row'} gap={2} pb={3}>
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 300 }}
        />
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 300 }}
        />
      </Stack>

      <Stack flexDirection={'row'} gap={2} pb={3}>
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 300 }}
        />
        <Stack flexDirection={'row'} gap={2} sx={{ flex: 1, minWidth: 300 }}>
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ flex: 1, minWidth: 200 }}
          />
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{ flex: 1, minWidth: 200 }}
          />
        </Stack>
      </Stack>

      <Stack flexDirection={'row'} gap={2} pb={3}>
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 300 }}
        />
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 200 }}
        />
      </Stack>

      <Stack flexDirection="row" gap={2} pb={3}>
        <Skeleton
          variant="rectangular"
          height={56}
          sx={{ flex: 1, minWidth: 300 }}
        />
        <Box sx={{ flex: 1, minWidth: 300 }} />
      </Stack>

      <Stack flexDirection="row" gap={2} pb={3}>
        <Skeleton
          variant="rectangular"
          height={80}
          sx={{ flex: 1, minWidth: 300 }}
        />
        <Skeleton
          variant="rectangular"
          height={80}
          sx={{ flex: 1, minWidth: 300 }}
        />
      </Stack>

      <Skeleton variant="rectangular" height={60} sx={{ width: '100%' }} />
    </Box>
  );
}
